module.exports = __webpack_public_path__ + "static/edit-product-custom-tabs-4c3656af5fe1b52d60da3b84def372f7.png";